class Xiaote {
  constructor() {
    this.isApp = false
  }

  getHeaders() {
    let req = new XMLHttpRequest()
    req.open('GET', document.location.href, false)
    req.send(null)
    let headerArr = req.getAllResponseHeaders().split('\n')
    let headers = {}
    headerArr.forEach(item => {
      if (item !== '') {
        let index = item.indexOf(':')
        let key = item.slice(0, index)
        let value = item.slice(index + 1).trim()
        headers[key] = value
      }
    })
    console.log(headers)
    return headers
  }

  getUserToken(cb) {
    this.setupWebViewJavascriptBridge((bridge) => {
      bridge.callHandler('getUserToken', {}, (res) => {
        cb(res)
      })
    })
  }

  openLoginView(cb) {
    this.setupWebViewJavascriptBridge((bridge) => {
      bridge.callHandler('openLoginView', {}, (res) => {
        cb(res)
      })
    })
  }

  bindVehicle(cb) {
    this.setupWebViewJavascriptBridge((bridge) => {
      bridge.callHandler('bindVehicle', {}, (res) => {
        cb(res)
      })
    })
  }

  verifyMobilePhone(cb) {
    this.setupWebViewJavascriptBridge((bridge) => {
      bridge.callHandler('verifyMobilePhone', {}, (res) => {
        cb(res)
      })
    })
  }

  // setupWebViewJavascriptBridge(callback) {
  //   if (window.WebViewJavascriptBridge) { return callback(WebViewJavascriptBridge) }
  //   if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback) }
  //   window.WVJBCallbacks = [callback]
  //   var WVJBIframe = document.createElement('iframe')
  //   WVJBIframe.style.display = 'none'
  //   WVJBIframe.src = 'https://__bridge_loaded__'
  //   document.documentElement.appendChild(WVJBIframe)
  //   setTimeout(() => { document.documentElement.removeChild(WVJBIframe) }, 0)
  // }
  setupWebViewJavascriptBridge (callback) {
    if (window.WebViewJavascriptBridge) {
      return callback(window.WebViewJavascriptBridge)
    }
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback)
    }
    window.WVJBCallbacks = [callback]
    let WVJBIframe = document.createElement('iframe')
    WVJBIframe.style.display = 'none'
    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'
    document.documentElement.appendChild(WVJBIframe)
    setTimeout(() => {
      document.documentElement.removeChild(WVJBIframe)
    }, 0)
  }
}

export default new Xiaote


// WEBPACK FOOTER //
// ./src/libs/xiaote.js